import { type FrontendFilterOptionId } from '@autone/redux/core';
import { z } from 'zod';

export const frontendFilterOptionIdSchema = z.custom<FrontendFilterOptionId>(
  (data) => {
    if (typeof data === 'string') return true;
    return false;
  },
  'Expected a FrontendFilterOptionId string. If compile error, use the buildFrontendFilterOption helper.',
);
